// Capture the current script element immediately during module initialization.
// In IIFE bundles (widget mode), document.currentScript points to the widget <script> tag,
// allowing us to derive the server origin for absolute asset URLs.
// In ES module builds (app mode), document.currentScript is null, so we fall back
// to relative paths which work fine on the same origin.
const currentScript = document.currentScript;

let _baseUrl = '';

if (currentScript && currentScript.src) {
  try {
    const url = new URL(currentScript.src);
    _baseUrl = url.origin;
  } catch {
    _baseUrl = '';
  }
}

export function assetUrl(path) {
  if (!_baseUrl) return path;
  return `${_baseUrl}${path.startsWith('/') ? path : '/' + path}`;
}
